"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Announced = void 0;
var Utilities_1 = require("../../Utilities");
var Announced_base_1 = require("./Announced.base");
var Announced_styles_1 = require("./Announced.styles");
exports.Announced = Utilities_1.styled(Announced_base_1.AnnouncedBase, Announced_styles_1.getStyles);
//# sourceMappingURL=Announced.js.map